import type { Catalog } from '..'
import { common } from './common'
import { settings } from './settings'
import { shell } from './shell'
import { home } from './home'
import { rail } from './rail'
import { connect } from './connect'
import { auth } from './auth'
import { account } from './account'
import { agentKeys } from './agentKeys'
import { webhooks } from './webhooks'
import { fonts } from './fonts'
import { models } from './models'
import { canvas } from './canvas'
import { stage } from './stage'
import { inspector } from './inspector'
import { panels } from './panels'
import { automations } from './automations'
import { workspace } from './workspace'
import { community } from './community'
import { admin } from './admin'
import { ui } from './ui'
import { hosted } from './hosted'
import { onboarding } from './onboarding'

export const ptBR: Catalog = {
  common,
  settings,
  shell,
  home,
  rail,
  connect,
  auth,
  account,
  agentKeys,
  webhooks,
  fonts,
  models,
  canvas,
  stage,
  inspector,
  panels,
  automations,
  workspace,
  community,
  admin,
  ui,
  hosted,
  onboarding,
}
